// Module-level throttle shared across every admin notification sound source
// (the global NotificationProvider AND per-page players). Because page-level
// players and the provider run on independent sockets, the same event can reach
// both - a shared gate guarantees a SINGLE beep per window instead of a double.
let lastPlayedAt = 0

export const canPlaySound = (minGapMs = 2000): boolean => {
  const now = Date.now()
  if (now - lastPlayedAt < minGapMs) return false
  lastPlayedAt = now
  return true
}
